import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid'
import CustomStore from 'devextreme/data/custom_store'
import React from 'react'
import { Card } from 'react-bootstrap'
import { GetAllReturnSalesData } from '../services/return-sales-service'
import ActionButtons from './ActionButtons'

const ReturnSalesDataList = () => {
    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    const response = await GetAllReturnSalesData(parameterList);
                    // return {
                    //     data: response?.data || [],
                    //     totalCount: response?.data.length || 0,
                    // };
                    return response
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">

                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Return Sales List</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {/* {HasPermission("Customer.Read") ? ( */}
                            <DataGrid
                                dataSource={dataSource()}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                showBorders={true}
                                columnAutoWidth={true}
                                columnHidingEnabled={false}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Paging defaultPageSize={10} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />
                                <SearchPanel visible={true} width={240} placeholder="Search..." />
                                <Summary>
                                    <TotalItem
                                        column="firstName"
                                        summaryType="count"
                                        displayFormat="Total Return Sales: {0}"
                                    />
                                </Summary>


                                <Column
                                    caption="Action"
                                    width="15%"
                                    cssClass="text-center"
                                    cellRender={({ data }) => (
                                        <div className="d-flex justify-content-center align-items-center gap-2">
                                            <ActionButtons
                                                selectedId={data.id as string}
                                            />
                                        </div>
                                    )}
                                />
                                {/* <Column dataField="id" caption="Id" dataType="number" cssClass="text-center" /> */}
                                {/* <Column dataField="returnCode" caption="Return Code" dataType="string" width={200}  /> */}
                                <Column dataField="returnCode" caption="Invoice No" dataType="string" width={200} />
                                <Column dataField="returnSaleOrderDate" caption="Return Date" dataType="date" width={200} format="dd/MM/yyyy" sortOrder='desc' />
                                <Column dataField="customerName" caption="Customer Name" dataType="string" />
                                <Column dataField="salesPersonName" caption="Sales Person" dataType="string" />
                                <Column dataField="returnSaleType" caption="Type" dataType="string" />
                                <Column dataField="totalReturnSaleOrderAmount" format="#,##0.00" caption="Total Amt" dataType="number" />


                                {/* {(HasPermission("Customer.Write") || HasPermission("Customer.Delete")) && */}

                                {/* } */}

                            </DataGrid>
                            {/* ) : (
                                    <div className="text-center fs-5 fw-bold">
                                        <Result
                                            status="403"
                                            title="403"
                                            subTitle="Sorry, you are not authorized to access this data."
                                            className="custom-result"
                                        />
                                    </div>
                                )} */}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default ReturnSalesDataList